import {
  collection,
  doc,
  getDocs,
  getDoc,
  updateDoc,
  query,
  orderBy,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { db } from "@/lib/firebase";
import { COLLECTIONS } from "@/constants/firestoreCollections";

function normalizeDates(data: Record<string, unknown>): Record<string, unknown> {
  const result = { ...data };
  for (const key of ["createdAt", "updatedAt", "paidAt"]) {
    const val = result[key];
    if (val && typeof (val as { toDate?: () => Date }).toDate === "function") {
      result[key] = (val as Timestamp).toDate();
    }
  }
  return result;
}

export async function getAllPayments() {
  const q = query(
    collection(db, COLLECTIONS.PAYMENTS),
    orderBy("createdAt", "desc")
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({
    id: d.id,
    ...normalizeDates(d.data()),
  }));
}

export async function getPaymentById(id: string) {
  const ref = doc(db, COLLECTIONS.PAYMENTS, id);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...normalizeDates(snap.data()) };
}

export async function updatePaymentStatus(
  id: string,
  status: string,
  notes?: string
) {
  const ref = doc(db, COLLECTIONS.PAYMENTS, id);
  const updates: Record<string, unknown> = {
    status,
    updatedAt: serverTimestamp(),
  };
  if (notes !== undefined) {
    updates.adminNotes = notes;
  }
  await updateDoc(ref, updates);
}

export async function verifyVoucherPayment(id: string, verified: boolean) {
  const ref = doc(db, COLLECTIONS.PAYMENTS, id);
  await updateDoc(ref, {
    voucherVerified: verified,
    updatedAt: serverTimestamp(),
  });
}
